module.exports = __webpack_public_path__ + "static/img/40.98adc75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/40.png
// module id = WGCT
// module chunks = 1